import superagent from 'superagent';

const GET = 'GET';
const POST = 'POST';
const PUT = 'PUT';
const DELETE = 'DELETE';

const sessionHeader = 'x-session-token';
const pubsubQuickstarHeader = 'pubsub-quickstart-app';
const anonIdHeader = 'anon-id';

// Takes baseUrl and returns function to hit pubnub portal api endpoints
// Returned function takes parameters:
// * requestType - any valid request type (GET, POST, ...)
// * path - endpoint path that should be hit
// * options - any additional options
//   * body - body to send as JSON
//   * query - url query parameters
//   * form - form data to send
//   * headers - additional headers
//   * sessionToken - token that will be used as session header to authorise request
const createRequestPubnubApi = baseUrl => (requestType, path, options = {}) => {
  const {
    body, query, form, headers, sessionToken, withCredentials,
  } = options;

  let request = superagent(requestType, baseUrl + path);

  if (body) {
    request.send(body);
  }

  if (query) {
    request.query(query);
  }

  if (form) {
    request.type('form');
    request.send(form);
  }

  if (headers) {
    request.set(headers);
  }

  if (sessionToken) {
    request.set(sessionHeader, sessionToken);
  }

  if (withCredentials) {
    request.withCredentials();
  }

  request.set('X-Requested-With', 'XMLHttpRequest');
  request.set(pubsubQuickstarHeader, true);

  try {
    if (!options.skipAnonId) {
      request.set(anonIdHeader, window.analytics.user().anonymousId());
    }
  } catch (err) {}

  return request;
};

export const apiEndpoint = window.location.hostname.endsWith('.pubnub.com') ?
  'https://admin.pubnub.com/api' : 'https://admin.ingress.caravan.integration.ps.pn/api';

export const requestPubnubApi = createRequestPubnubApi(apiEndpoint);

// Creates request that will send auth cookies with the request
export const withCredentials = requestFn => (path, options = {}) => requestFn(path, { withCredentials: true, ...options });

// Use this methods
export const requestPubnubApiGET = (path, options = {}) => requestPubnubApi(GET, path, options);
export const requestPubnubApiPOST = (path, options = {}) => requestPubnubApi(POST, path, options);
export const requestPubnubApiPUT = (path, options = {}) => requestPubnubApi(PUT, path, options);
export const requestPubnubApiDELETE = (path, options = {}) => requestPubnubApi(DELETE, path, options);



// WEBPACK FOOTER //
// ./src/apiClient.js